import React from 'react';
import UserAuth, { useAuth } from './auth';
import RegisterForm, { useRegisterForm } from './registerForm';
import ProfileContext, { useProfile } from './profile';
import NotificationContext, { useNotification } from './notification';
import DepartmentContext, { useDepartments } from './department';
import { AlertProvider } from './alert';
import { EventsProvider } from './events';
import { AppProvider, useApp } from './app';
import SpecialtiesProvider from './specialties';
import CorrespondencesProvider from './correspondences';
import ClientsProvider from './clients';
import SolicitationContext from './solicitation';
import BankAccountProvider from './bankAccounts';
import PixAccountProvider from './pixAccounts';
import ConversationContext from './conversation';
import PostContextProvider from './posts';
import BranchProvider from './branch';
import CollaboratorProvider from './collaborator';
import JobValuesProvider from './jobvalues';
import CourtsProvider from './courts';
import SolucionareProvider from './solucionare';
import PaymentProvicer from './payment';
import DistrictsProvider from './districts';
import InformationBaseContextProvider, { useInformationBase } from './informationBase';
import CompanyProvider from './company';
import { ReportProvider } from './report';
import { UserRoleProvider } from './userRole';
import { TutorialProgressProvider } from './tutorialProgress';
import PlansContextProvider from './plans';
const GlobalContext: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <TutorialProgressProvider>
      <UserAuth>
        <AppProvider>
          <AlertProvider>
            <UserRoleProvider>
              <ReportProvider>
                <InformationBaseContextProvider>
                  <JobValuesProvider>
                    <CollaboratorProvider>
                      <BranchProvider>
                        <PixAccountProvider>
                          <BankAccountProvider>
                            <ClientsProvider>
                              <CourtsProvider>
                                <CorrespondencesProvider>
                                  <SpecialtiesProvider>
                                    <NotificationContext>
                                      <ConversationContext>
                                        <DistrictsProvider>
                                          <CompanyProvider>
                                            <SolicitationContext>
                                              <PaymentProvicer>
                                                <SolucionareProvider>
                                                  <PlansContextProvider>
                                                    <RegisterForm>
                                                      <ProfileContext>
                                                        <PostContextProvider>
                                                          <DepartmentContext>
                                                            <EventsProvider>
                                                              {children}
                                                            </EventsProvider>
                                                          </DepartmentContext>
                                                        </PostContextProvider>
                                                      </ProfileContext>
                                                    </RegisterForm>
                                                  </PlansContextProvider>
                                                </SolucionareProvider>
                                              </PaymentProvicer>
                                            </SolicitationContext>
                                          </CompanyProvider>
                                        </DistrictsProvider>
                                      </ConversationContext>
                                    </NotificationContext>
                                  </SpecialtiesProvider>
                                </CorrespondencesProvider>
                              </CourtsProvider>
                            </ClientsProvider>
                          </BankAccountProvider>
                        </PixAccountProvider>
                      </BranchProvider>
                    </CollaboratorProvider>
                  </JobValuesProvider>
                </InformationBaseContextProvider>
              </ReportProvider>
            </UserRoleProvider>
          </AlertProvider>
        </AppProvider>
      </UserAuth>
    </TutorialProgressProvider>
  );
};
export {
  useAuth,
  useApp,
  useRegisterForm,
  useProfile,
  useDepartments,
  useNotification,
  useInformationBase,
};
export { usePlans } from './plans';
export default GlobalContext;
